import { Menu, MenuHandler, Button, MenuList, MenuItem, Typography, Avatar } from '@material-tailwind/react';
import IonIcon from '@reacticons/ionicons';
import React from 'react'
import AIcon from '../../partials/AIcon';
import { useAuth } from '../../../hooks/useAuth';
import { useShared } from '../../../hooks/useShared';
const profileMenuItems = [
    {
        label: "My Profile",
        name:"پروفایل من",
        icon: 'person-circle-outline',
    },
    {
        label: "My Company",
        name:'شرکت من',
        icon: 'business-outline',
    },
    {
        label: "Sign Out",
        name:'خروج از سیستم',
        icon: 'log-out-outline',
    },
];



export default function UserProfileMenu() {
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);
    const closeMenu = () => setIsMenuOpen(false);
    const { logout, errorMessage, setErrorMessage, loading } = useAuth();
    const { auth, navigate, getLanguage,consts } = useShared();

    const triggers = {
        onMouseEnter: () => setIsMenuOpen(true),
        onMouseLeave: () => setIsMenuOpen(false),
      };


    const handleProfileMenu = (label) => {
        if (label === 'Sign Out') {
            auth.logout()
        }
        else if (label === "My Profile") {
            navigate("/db/profile", { replace: true })
        }

        else if (label === "My Company") {
            navigate("/db/companies/company", { replace: true })
        }
        closeMenu()
    }


    return (
        <Menu open={isMenuOpen} handler={setIsMenuOpen} placement="bottom-end" 
          animate={{
                mount: { y: 0 },
                unmount: { y: 25 },
            }}>
            <MenuHandler>
                <Button
                    variant="text"
                    color="blue-gray"
                    className={` flex items-center gap-1 rounded-full py-0.5 pr-2 pl-0.5 lg:ml-auto md:border md:border-red-100`}
                >
                   {/*  <AIcon name="person-circle-outline" size={25} className="text-green-500" /> */}
                    <Avatar src={auth?.user?.user?.image_path ? consts.BASE_URL + auth?.user?.user?.image_path : consts.DEFULAT_USER_PHOTO} alt={auth?.user?.user?.first_name}
                     className="h-6 w-6 md:h-8 md:w-8" />

                    <span className="md:flex flex-col ml-2 capitalize text-left  md:w-36 hidden">
                        <span className="truncate w-30   tracking-wide leading-none text-white ">{auth?.user?.user?.full_name}</span>
                        <span className="truncate w-30 text-gray-300 text-xs leading-none mt-1">{auth?.user?.user?.email}</span>
                    </span>

                    <AIcon name = "chevron-down-outline" className={` text-white h-8 w-8 transition-transform ${isMenuOpen ? "rotate-180" : ""}`} />
                  
                </Button>
            </MenuHandler>
            <MenuList className=" border border-main-color  p-1" >
                {profileMenuItems.map(({ label, icon, name }, key) => {
                    const isLastItem = key === profileMenuItems.length - 1;
                    return (
                        <React.Fragment key={label}>
                            {isLastItem && <hr className="my-1 border-blue-gray-50" />}
                            <MenuItem
                                key={label}
                                onClick={() => handleProfileMenu(label)}
                                className={`flex items-center  gap-2 rounded ${isLastItem
                                    ? "hover:bg-red-500/10 focus:bg-red-500/10 active:bg-red-500/10"
                                    : "" 
                                    }  ${getLanguage()==='dr'? 'justify-between':''} `}>

                                <AIcon size={20} name={icon} className={` ${isLastItem ? "text-red-500" : "text-purple-600"}`} />

                                <Typography
                                    as="span"
                                    variant="small"
                                    className="font-normal"
                                    color={isLastItem ? "red" : "inherit"}
                                >
                                    {getLanguage()==='en'? label:name}
                                </Typography>
                            </MenuItem>
                        </React.Fragment>
                    );
                })}
            </MenuList>
        </Menu>
    )
}
